import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk-legacy/ui-react-utils';
import ChartHeader from '../chart-header';
import PriceHistoryChart from '../price-history-chart';
import styles, { PADDING_OFFSET } from './asset-position-modal.styles';
import ResponsiveDimensionValues from '../../../../../../../src/components/common/responsive-dimension-values';
function AssetPositionModal({
  row = {},
  chartHeaderComponent,
  selectedChartInteractionValue,
  onChartInteractionChange,
}) {
  const {
    dayChange,
    dayChangePercentage,
    chartHeaderValue,
    chartHeaderValueUnit,
    priceHistory,
    positionCurrency,
  } = row;

  const ChartHeaderComponent = chartHeaderComponent;
  const chartWidth = ResponsiveDimensionValues.windowWidth - (PADDING_OFFSET * 2);
  const chartHeight = 265 * (ResponsiveDimensionValues.windowHeight / 375);

  return (
    <View style={styles.root} testID="fullscreen-view">
      <View style={styles.graphHeader}>
        <ChartHeaderComponent
          dayChange={dayChange}
          dayChangePercentage={dayChangePercentage}
          value={chartHeaderValue}
          valueUnit={chartHeaderValueUnit}
          testID="fullscreen-header"
        />
      </View>
      <View testID="fullscreen-graph">
        <PriceHistoryChart
          width={chartWidth}
          height={chartHeight}
          animated={false}
          data={priceHistory}
          currency={positionCurrency}
          selectedInteractionValue={selectedChartInteractionValue}
          onInteractionChange={onChartInteractionChange}
        />
      </View>
    </View>
  );
}

AssetPositionModal.propTypes = {
  row: PropTypes.shape({
    dayChange: PropTypes.number,
    dayChangePercentage: PropTypes.number,
    chartHeaderValue: PropTypes.number,
    chartHeaderValueUnit: PropTypes.string,
    priceHistory: PropTypes.array,
    positionCurrency: PropTypes.string,
  }),
  chartHeaderComponent: PropTypes.func,
  selectedChartInteractionValue: PropTypes.instanceOf(Date),
  onChartInteractionChange: PropTypes.func,
};

AssetPositionModal.defaultProps = {
  chartHeaderComponent: ChartHeader,
};

export default pure(AssetPositionModal);
